import React from "react";

const BikeAvailabilityStatusIcon = ({ soldOut }: { soldOut: boolean }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="8" fill={soldOut ? "#FFD7C0" : "#ABDD96"} />
      <circle cx="8" cy="8" r="3" fill={soldOut ? "#F45338" : "#3F7E44"} />
    </svg>
  );
};

export default BikeAvailabilityStatusIcon;
